/**
 * 
 * AccordionList.js
 * 
 */
export default class AccordionList {

    constructor() {
        this.name = 'AccordionList';
        this.accordionLists            = document.querySelectorAll('.js-accordion-list');

        if (this.accordionLists.length) {
            this._init();
        }
    }

    // Public Functions
    
    
    // 'Private' Functions
    _init() {
        /**
         * 
         *  Loop through all Accordion Lists, and enable them 
         * 
         * */
        for (var i = 0; i < this.accordionLists.length; i ++) {

            let accordionList = this.accordionLists[i];
            
            this._initAccordionList(accordionList);
        }
    }

    _initAccordionList(accordionList) {
        let listItems = accordionList.querySelectorAll('.list-item');

        for (let i = 0; i < listItems.length; i ++) {
            let item = listItems[i];
            let itemHeight = item.clientHeight;
            item.setAttribute('data-closed-height', itemHeight);
            item.addEventListener('click', this._handleListItemClick);
        }
    }

    _handleListItemClick(e) {
        let item = e.currentTarget;
        let closedHeight = Number(item.getAttribute('data-closed-height'));
        let contentHeight = item.querySelector('p').clientHeight;
        let totalHeight = Number(closedHeight + contentHeight) - 25;
        let textContainer = item.querySelector('.text-container');

        if (!item.classList.contains('expanded')) {
            TweenMax.to(textContainer, 0.5, { height: totalHeight });
            item.classList.add('expanded');
        } else {
            TweenMax.to(textContainer, 0.5, { height: 0 });
            item.classList.remove('expanded');
        }
    }
}
